import { PLANTS } from '@/plants';

export const pad2 = (n) => String(n).padStart(2, '0');

const IMG_BASE = `${process.env.PUBLIC_URL}/databank/images`;

export const plateImg = (p) => `${IMG_BASE}/plant_${pad2(p.plant_no)}.jpg`;
export const zoomImg = (p) => `${IMG_BASE}/plant_${pad2(p.plant_no)}_zoom.jpg`;
export const thumbImg = (p) => `${IMG_BASE}/thumb_${pad2(p.plant_no)}.jpg`;

export const cleanTribe = (t) => (t ? t.replace(/\.$/, '').trim() : '');

export const findPlant = (no) => PLANTS.find((p) => p.plant_no === Number(no));

const tribeCounts = {};
PLANTS.forEach((p) => {
    const t = cleanTribe(p.tribe) || 'Unclassified';
    tribeCounts[t] = (tribeCounts[t] || 0) + 1;
});

export const TRIBES = Object.keys(tribeCounts).sort((a, b) => tribeCounts[b] - tribeCounts[a]);
export const TRIBE_COUNTS = tribeCounts;

export const STATS = {
    species: PLANTS.length,
    tribes: TRIBES.length,
    plates: PLANTS.length * 3,
};

export { PLANTS };
